import React from 'react';

const CreatePasswordView = () => {
  return <div>CreatePasswordView</div>;
};

export default CreatePasswordView;
